function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  border-collapse: collapse;\n  width: 100%;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

import styled from "../../../theme";
export var TableWrapper = styled.table(_templateObject());